export default __webpack_public_path__ + "4ea9b2828906ca134a738ee418b07515.svg";